import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { api } from "../lib/api";
import { formatApiError } from "../contexts/AuthContext";

export function PortalForgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/portal/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <Layout title="Forgot password | The Authority Gap" path="/portal/forgot">
      <section style={{ background: "#090909", padding: "80px 20px" }}>
        <div className="tag-card" data-testid="portal-forgot-card" style={{ maxWidth: 420, margin: "0 auto", padding: 32 }}>
          <h2 className="tag-h2" style={{ marginBottom: 16 }}>Reset your password</h2>
          {sent ? (
            <p data-testid="portal-forgot-sent" style={{ color: "#bbb", fontSize: 13, lineHeight: 1.7 }}>
              If an account exists for that email, a reset link is on its way. Check your inbox (and spam).
            </p>
          ) : (
            <form onSubmit={submit}>
              <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Email</label>
              <input data-testid="portal-forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tag-input" style={{ marginBottom: 20 }} />
              <button data-testid="portal-forgot-submit" type="submit" className="btn-primary" style={{ width: "100%" }}>Send reset link</button>
            </form>
          )}
          <div style={{ marginTop: 16, fontSize: 12 }}>
            <Link to="/portal/login" style={{ color: "#777" }}>← Back to sign in</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default function PortalResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    try {
      await api.post("/portal/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <Layout title="Reset password | The Authority Gap" path="/portal/reset-password">
      <section style={{ background: "#090909", padding: "80px 20px" }}>
        <div className="tag-card" data-testid="portal-reset-card" style={{ maxWidth: 420, margin: "0 auto", padding: 32 }}>
          <h2 className="tag-h2" style={{ marginBottom: 16 }}>Set a new password</h2>
          {!token && <p style={{ color: "#c66", fontSize: 13 }}>Missing reset token. Request a new link from the forgot-password page.</p>}
          {done ? (
            <p data-testid="portal-reset-success" style={{ color: "#bbb", fontSize: 13 }}>
              Password updated. <Link to="/portal/login" style={{ color: "#FF6575" }}>Sign in</Link>
            </p>
          ) : (
            token && (
              <form onSubmit={submit}>
                <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>New password (min 8 chars)</label>
                <input data-testid="portal-reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="tag-input" style={{ marginBottom: 20 }} />
                <button data-testid="portal-reset-submit" type="submit" className="btn-primary" style={{ width: "100%" }}>Update password</button>
              </form>
            )
          )}
        </div>
      </section>
    </Layout>
  );
}
